import { PspRules } from "@CommonTypes/backend/PspRules";
import type { DividerRuleError } from "@CommonUtils/pog/dividerPolicyValidation";
import type { HorizontalRectanglesOptionError } from "@CommonUtils/pog/horizontalRectanglesOptions";

export const RoutePostMerchflowApplyToBases = "/merchflow/apply-to-bases";

/**
 * The 400 for an unusable divider / loader rule (POST /merchflows/:merchflowId/base-pog
 * sends it too), or for an unusable horizontal-rectangles override (store generation only).
 */
export type ErrorPostMerchflowApplyToBases = DividerRuleError | HorizontalRectanglesOptionError;

export interface PayloadPostMerchflowApplyToBases {
  base_pog_id: number;
  psp_rules: PspRules;
}

export interface ResponsePostMerchflowApplyToBases {
  store_pog_trigger_id: number;
}
